export class EntiteFacturation {
  public Ident: string;
  public Nom: string;
  public ApiTokenFulll: string;
  public ApiCodeBddFulll: string;
  public IsFulll: boolean;
  public ApiIdentDso: string;
  public ApiPswDso: string;
  public IsDso: boolean;
  public ApiPathMCF: string;
  public IsMyCompanyFiles: boolean;
}
